import api from "./axios";

// Timeout 10 minut dla długo trwających jobów
const LONG_JOB_TIMEOUT = 10 * 60 * 1000; // 10 minutes

export async function runFetcherJob() {
  return api.post("/admin/fetcher-job", null, {
    timeout: LONG_JOB_TIMEOUT
  });
}

export async function runGoogleAdsFetcherJob(mode: "standard" | "initial" = "standard") {
  return api.post("/admin/google-ads-fetcher-job", null, {
    params: { mode },
    timeout: LONG_JOB_TIMEOUT
  });
}

export async function runPushToSheetsJob() {
  return api.post("/admin/push-to-sheets-job", null, {
    timeout: LONG_JOB_TIMEOUT
  });
}

export async function runFakturowniaJob() {
  return api.post("/admin/fakturownia-job", null, {
    timeout: LONG_JOB_TIMEOUT
  });
}